import axios from 'axios';
import { cloneDeep } from 'lodash';

import { getHeaders } from './getHeaders';

/**
 * функция для загрузки по порциям
 * @param {number} portionSize размер порции
 * @param {array} dataArray массив с данными
 * @param {number} timeout таймаут
 * @param {boolean} isAuth таймаут
 * @returns массив ответов
 */
const portionDataPost = async (options) => {
    const { portionSize, dataArray, timeout, isAuth } = options;
    const dataArrayCopy = cloneDeep(dataArray);

    const result = [];

    const subarray = []; //массив в который будет выведен результат.
    for (let i = 0; i < Math.ceil(dataArrayCopy.length / portionSize); i++) {
        subarray[i] = dataArrayCopy.slice(i * portionSize, i * portionSize + portionSize);
    }

    for (let array of subarray) {
        const promises = [];
        array.forEach((element) => {
            const promise = axios
                .post(element.url, element.dataForPost, {
                    timeout,
                    auth: isAuth && {
                        username: element?.user,
                        password: element?.pass,
                    },
                    headers: { ...getHeaders(), ...element?.headers },
                })
                .then((res) => {
                    return res.data;
                })
                .then((data) => ({
                    response: data,
                    initialData: { ...element.initialData },
                    extraArgs: element?.extraArgs,
                }))
                .catch((error) => {
                    return {
                        error: error.message || 'Post error',
                        initialData: { ...element.initialData },
                        extraArgs: element?.extraArgs,
                    };
                });
            promises.push(promise);
        });

        await Promise.all(promises).then((responses) => {
            responses.forEach((response) => {
                result.push(response);
            });
        });
    }

    return result;
};

export default portionDataPost;
